import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Icon } from 'rsuite';
import {
  moveElementDown,
  moveElementUp,
  getIsLastSortableElement,
} from '../../redux/modules/campaigns';
import styles from './ElementSortButtons.module.less';

const ElementSortButtons = ({
  _moveElementDown,
  _moveElementUp,
  idx,
  isLastSortableElement,
}) => {
  // We don't need a selector for this
  const isFirstElement = idx === 0;

  return (
    <section data-testid="elementSortButtonSection" className={styles.vpSortOrderContainer}>
      <Icon
        icon="chevron-up"
        data-testid={`sort-up-${idx}`}
        className={`${isFirstElement ? styles.vpSortDisabled : ''}`}
        onClick={() => {
          if (isFirstElement) {
            return null;
          }

          _moveElementUp(idx);
        }}
      />
      <Icon
        icon="chevron-down"
        data-testid={`sort-down-${idx}`}
        className={`${isLastSortableElement ? styles.vpSortDisabled : ''}`}
        onClick={() => {
          if (isLastSortableElement) {
            return null;
          }

          _moveElementDown(idx);
        }}
      />
    </section>
  );
}

ElementSortButtons.propTypes = {
  _moveElementDown: PropTypes.func,
  _moveElementUp: PropTypes.func,
  idx: PropTypes.number,
  isLastSortableElement: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    isLastSortableElement: getIsLastSortableElement(state, ownProps.idx),
  };
}

const mapDispatchToProps = {
  _moveElementDown: moveElementDown,
  _moveElementUp: moveElementUp,
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementSortButtons);



// WEBPACK FOOTER //
// ./src/components/CampaignEdit/ElementSortButtons.jsx